import { gql } from 'graphql-request';

export const getTestRunsTableDataQuery = gql`
  query TestRunsTableDataPaged(
    $testIds: [String!]
    $assetIds: [String!]
    $daysBack: Int!
    $testExecutionFilters: [Filter!]
    $sort: TestExecutionFieldPaginationSort
    $cursor: String
    $limit: Int!
    $search: String
  ) {
    latestTestExecutionsPaged(
      filters: {
        assetIds: $assetIds
        testIds: $testIds
        daysBack: $daysBack
        search: $search
        includeDeleted: false
      }
      testExecutionFilters: $testExecutionFilters
      sort: $sort
      cursor: $cursor
      limit: $limit
    ) {
      items {
        ...TestRunFragment
      }
      pageInfo {
        hasNextPage
        nextCursor
      }
    }
  }

  fragment TestRunFragment on LatestTestExecution {
    test {
      id
      name
      type
      tags
      owners
      description
      severity
      config {
        type
        ... on AnomalyDetectionTestConfig {
          anomalyConfig {
            sensitivity
            anomalyDirection
          }
        }
        ... on FreshnessAnomalyDetectionTestConfig {
          anomalyConfig {
            sensitivity
          }
        }
        ... on PipelineTaskPerformanceTestConfig {
          sensitivity
          anomalyDirection
        }
      }
      tableAsset {
        id
        dbName
        schemaName
        tableName
        tags
        owners
        isCritical
        subscribers
        path
        name
      }
    }
    execution {
      subTestUniqueId
      testId
      subType
      status
      executionTimestamp
      columnName
      durationSeconds
      query
    }
    performanceStats(daysBack: $daysBack) {
      passedCount
      warningsCount
      failuresCount
      errorsCount
      totalCount
      failRate
      medianExecTime
      avgExecTime
    }
  }
`;

export const getTestRunsFilterOptionsQuery = gql`
  query TestRunsFilterOptions(
    $testIds: [String!]
    $assetIds: [String!]
    $daysBack: Int
    $search: String
    $testExecutionFilters: [Filter!]
  ) {
    latestTestExecutionsFilterOptions(
      filters: {
        assetIds: $assetIds
        testIds: $testIds
        daysBack: $daysBack
        includeDeleted: false
        search: $search
      }
      testExecutionFilters: $testExecutionFilters
    ) {
      field
      options {
        value
        count
      }
    }
  }
`;

export const getTestRunExecutionHistoryQuery = gql`
  query TestRunExecutionHistory(
    $id: String!
    $startTime: DateTime!
    $endTime: DateTime!
  ) {
    latestTestExecution(id: $id) {
      test {
        id
        executionHistory(
          startTime: $startTime
          endTime: $endTime
          subTestUniqueId: $id
          sortDirection: ASC
        ) {
          id
          executionTimestamp
          status
          failures
        }
      }
    }
  }
`;
